
export enum ProductType {TRAVEL = 'travel', EMTPL = 'mtpl', GREEN_CARD = 'green-card'}